import { Flex, Button, Text } from '@radix-ui/themes';
import React from 'react';
import { Icon } from '@iconify/react';

const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
  const siblingCount = 1;
  const boundaryCount = 1;

  const range = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => start + i);

  const getPageNumbers = () => {
    const totalNumbers = siblingCount * 2 + 3 + boundaryCount * 2;
    if (totalNumbers >= totalPages) return range(1, totalPages);

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPages);

    const shouldShowLeftEllipsis = leftSiblingIndex > 2 + boundaryCount;
    const shouldShowRightEllipsis = rightSiblingIndex < totalPages - (1 + boundaryCount);

    const leftBoundary = range(1, boundaryCount);
    const rightBoundary = range(totalPages - boundaryCount + 1, totalPages);

    if (!shouldShowLeftEllipsis && shouldShowRightEllipsis) {
      const leftRange = range(1, 3 + siblingCount * 2);
      return [...leftRange, '...', ...rightBoundary];
    }
    if (shouldShowLeftEllipsis && !shouldShowRightEllipsis) {
      const rightRange = range(totalPages - (2 + siblingCount * 2), totalPages);
      return [...leftBoundary, '...', ...rightRange];
    }
    if (shouldShowLeftEllipsis && shouldShowRightEllipsis) {
      const middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [...leftBoundary, '...', ...middleRange, '...', ...rightBoundary];
    }
    return range(1, totalPages);
  };

  const pageNumbers = getPageNumbers();

  return (
    <Flex gap="1" align="center" justify="center" mt="4" className="text-gray-900">
      <Button
        variant="soft"
        size="2"
        disabled={currentPage === 1}
        onClick={() => onPageChange(1)}
        className="w-9 h-9 flex items-center justify-center rounded disabled:opacity-50 hover:bg-gray-200 focus:outline focus:outline-1 focus:outline-offset-1"
      >
        <Icon icon="mdi:chevron-double-left" width="20" height="20" />
      </Button>
      <Button
        variant="soft"
        size="2"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="w-9 h-9 flex items-center justify-center rounded disabled:opacity-50 hover:bg-gray-200 focus:outline focus:outline-1 focus:outline-offset-1 mr-2"
      >
        <Icon icon="mdi:chevron-left" width="20" height="20" />
      </Button>
      {pageNumbers.map((page, index) =>
        page === '...' ? (
          <Text key={index} size="2" className="w-9 h-9 flex items-center justify-center">
            …
          </Text>
        ) : (
          <Button
            key={index}
            variant={currentPage === page ? 'solid' : 'soft'}
            size="2"
            onClick={() => onPageChange(page)}
            className={`w-9 h-9 rounded flex items-center justify-center ${
              currentPage === page ? 'bg-gray-900 text-white' : 'hover:bg-gray-200 text-gray-900'
            } focus:outline focus:outline-1 focus:outline-offset-1`}
          >
            {page}
          </Button>
        )
      )}
      <Button
        variant="soft"
        size="2"
        disabled={currentPage === totalPages || totalPages === 0}
        onClick={() => onPageChange(currentPage + 1)}
        className="w-9 h-9 flex items-center justify-center rounded disabled:opacity-50 hover:bg-gray-200 focus:outline focus:outline-1 focus:outline-offset-1 ml-2"
      >
        <Icon icon="mdi:chevron-right" width="20" height="20" />
      </Button>
      <Button
        variant="soft"
        size="2"
        disabled={currentPage === totalPages || totalPages === 0}
        onClick={() => onPageChange(totalPages)}
        className="w-9 h-9 flex items-center justify-center rounded disabled:opacity-50 hover:bg-gray-200 focus:outline focus:outline-1 focus:outline-offset-1"
      >
        <Icon icon="mdi:chevron-double-right" width="20" height="20" />
      </Button>
    </Flex>
  );
};

export default PaginationComponent;